<div class="copoun-wrapper" *ngIf="couponService.displayCouponCodeForm">

  

  <div id="coupon-code-form" class="coupon-code-wrapper" (click)="clickOnBlankarea()" >
    <div class="coupon-code-form col-md-4" (click)="preventDefault()">
      <div class="row">
        <div class="col-md-12">
          <div class="close" (click)="closeWindow()">X</div>
          <div class="coupon-logo"></div>
        </div>
      </div>
      <div class="row ">
        <div class="col-md-12" *ngIf="couponService.listOfAvailbleCoupons!=null && couponService.listOfAvailbleCoupons.length>0">
          <div class="coupon-code-title ">
            בחר קופון למימוש וקבל קוד קופון באימייל
          </div>
          <div class="row justify-content-md-center">


            <div class=" col-md-12">
              <div class="form-group col-md-12">
                <label for="copun-name" class="title-label">שם קופון</label>
                <select (change)="couponChange($event)" id="copun-name" class="form-control">
                  <option *ngFor="let coupon of couponService.listOfAvailbleCoupons" value="{{coupon.Id}}" title="{{coupon.CouponDescription}}">
                    <span>{{coupon.CouponName}} </span>

                    <span> (זמין למימוש עד </span>
                    <span>{{coupon.Endtime | date: 'dd/MM/yyyy'}})</span>
                  </option>

                </select>
                <div class="coupon-left" [ngClass]="{'no-coupon-left': couponLeft==0}">
                  <div *ngIf="couponLeft>1">
                    <span>נותרו </span>
                    <span>{{couponLeft}} קופונים</span>

                  </div>
                  <div *ngIf="couponLeft==1">
                    נותר קופון 1
                  </div>
                  <span *ngIf="couponLeft>=1"> מתוך {{currentCoupon.MaxCouponCodes}}</span>
                  <div *ngIf="couponLeft==0">
                    אזלו הקופונים למבצע זה
                  </div>
                </div>
                <div class="choosen-coupon-details">
                  <span class="choosen-coupon-details-title">פרטי הקופון: </span>
                  <span>{{currentCoupon.CouponDescription}}</span>
                </div>

              </div>
            </div>

            <div class=" col-md-12">
              <div class="form-group col-md-12">
                <label for="coupon-code-email" class="title-label">אימייל*</label>
                <input type="email" class="form-control" id="coupon-code-email" [(ngModel)]="couponCode.UserEmail" />
                <div class="alert-danger" *ngIf="fieldsToValidate[0]">כתובת אימייל לא תקינה</div>
              </div>
            </div>
            <div class=" col-md-12">
              <div class="form-group col-md-12">
                <label for="coupon-code-email" class="title-label">אימות אימייל*</label>
                <input type="email" class="form-control" onpaste="return false" id="coupon-code-email" [(ngModel)]="UserEmailCopy" />
                <div class="alert-danger" *ngIf="fieldsToValidate[2]">אימייל אימות לא זהה לאימייל שהקלדת</div>
              </div>
            </div>
            <div class=" col-md-12">
              <div class="col-sm-12 input-field" *ngIf="displayGoogleRobot">
                <re-captcha class="recaptcha" (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
                <div class="alert-danger" *ngIf="fieldsToValidate[1]">אנא סמן ב-v את "אני לא רובוט"</div>
              </div>

            </div>

            <div class="col-md-12">
              <div class="form-group col-md-6">
                <div class="send-btn" (click)="send()">
                  שלח
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="couponService.listOfAvailbleCoupons==null && couponService.listOfAvailbleCoupons.length==0">
          אין כרגע קופונים זמינים
        </div>
      </div>
    </div>
  </div>
</div>

<div class="msg-wrapper" *ngIf="displayDoublesError || displaySuccessError || displayGeneralError">
  <div *ngIf="displayDoublesError" class="faild-msg">
    <span class="close-x-msg" (click)="displayDoublesError=false;">x</span>
    מצטערים, לא ניתן לקבל פעמיים קופון לאותו משתמש.
  </div>
  <div *ngIf="displaySuccessError" class="success-msg">
    <span class="close-x-msg" (click)="displaySuccessError=false;">x</span>
    <div class="success-msg-main-details">
        קוד קופון נשלח בהצלחה לכתובת המייל שהוזנה.
    </div>
    
    <div class="success-msg-aditional-data">
      שימו לב,
      <br>
      במקרה שאינכם רואים את המייל שנשלח בתיבת הדואר שלכם בדקו את תיבת הספאם. יתכן שההודעה הגיעה לשם.
      בכל מקרה של בעיה ניתן לפנות אלינו ישירות בוואטצאפ.
    </div>
  </div>
  <div *ngIf="displayGeneralError" class="faild-msg">
    <span class="close-x-msg" (click)="displayGeneralError=false;">x</span>
    אופס! התרחשה תקלה. אנא נסה שוב מאוחר יותר
  </div>
</div>